import React from 'react';

/**
 * **공덱 점수** 딱지 — 그 판 양쪽 룬으로 시뮬레이션 300번 돌린 공덱 승률의 등급(서버 utils/simGrade, 사용자 2026-10-26).
 *   S 95% 이상 · A 90 · B 80 · C 70 · D 그 아래
 * 꽉 찬 네모에 등급만. 색은 게임 등급색(분홍 · 보라 · 파랑 · 하늘 · 회색, 사용자 2026-10-26 초안 4 + C 하늘).
 * 승률 숫자는 어디에도 적지 않는다(사용자 2026-10-26). 아직 매기지 않은 판(룬이 없거나 차례를 기다리는 판)은 빈칸.
 */
const COLOR: Record<string, string> = {
    S: '#f0508f',
    A: '#9b62f5',
    B: '#2f8de8',
    C: '#3fb6e0',
    D: '#7d838c'
};

export default function GradeBadge({ grade, size = 30 }: { grade?: string | null; win?: number | null; size?: number }) {
    if (!grade) return null;
    const c = COLOR[grade] || COLOR.D;
    return (
        <span
            // 승률 숫자는 보이지 않는다(사용자 2026-10-26 "승률은 표시하지마") — 등급만
            title={`공덱 점수 ${grade}`}
            style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: size, height: size, borderRadius: Math.round(size / 3.3),
                background: c, color: '#fff', fontWeight: 900, fontSize: Math.round(size * 0.5),
                boxShadow: `0 2px 6px ${c}55`, flexShrink: 0, lineHeight: 1
            }}
        >{grade}</span>
    );
}
